import React from 'react';

interface RobotChatIconProps {
  className?: string;
  size?: number;
}

const RobotChatIcon: React.FC<RobotChatIconProps> = ({ className = "", size = 24 }) => {
  return (
    <img
      src="/images/robot-chat-icon.png"
      alt="Robot Chat Icon"
      width={48}
      height={48}
      className={`${className} w-12 h-12`}
    />
  );
};

export default RobotChatIcon;
